var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2222_83382)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.938 1.876a.23.23 0 0 0-.23.229v.687h4.355c.632 0 1.146.513 1.146 1.146v4.354h.687a.23.23 0 0 0 .23-.229V2.105a.23.23 0 0 0-.23-.23zm5.27 7.333h.688c.633 0 1.146-.513 1.146-1.146V2.105c0-.633-.513-1.146-1.146-1.146H3.938c-.633 0-1.146.513-1.146 1.146v.687h-.688c-.633 0-1.146.513-1.146 1.146v5.958c0 .633.514 1.146 1.146 1.146h5.959c.632 0 1.146-.513 1.146-1.146zm-7.104-5.5a.23.23 0 0 0-.229.23v5.957c0 .127.103.23.23.23h5.958a.23.23 0 0 0 .229-.23V3.938a.23.23 0 0 0-.23-.229z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2222_83382"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgCopy;